import PopUp from './PopUp';

export default PopUp ;



// WEBPACK FOOTER //
// ./src/containers/PopUp/index.js